// Shared service catalog used by /pages/SacredCrown.jsx and /pages/Services.jsx
// Keep this file as the single source of truth.

export const SERVICES = [
  {
    id: "mini",
    name: "The Mini Reset",
    duration: "30 Minutes",
    price: "$55",
    tagline: "A quick restorative pause.",
    image: "/images/mini.jpg",
    intro: "A brief escape from the demands of the day.",
    description:
      "The Mini Reset is designed for women seeking a moment of stillness, comfort, and calm. Through gentle hair brushing, soothing scalp relaxation, aromatherapy, and quiet intention, this session offers a restorative pause to help you slow down, clear your mind, and return to yourself.",
    includes: [
      "Gentle hair brushing",
      "Light scalp relaxation",
      "Aromatherapy",
      "Warm eye pillow",
      "Herbal tea",
    ],
  },
  {
    id: "sacred-crown",
    name: "The Sacred Crown Ritual",
    duration: "60 Minutes",
    price: "$111",
    tagline: "Your signature experience.",
    image: "/images/service-1.jpg",
    intro: "Our signature experience and the heart of Sacred Crown Studio.",
    description:
      "Designed to invite deep relaxation and comfort, this nurturing ritual combines intentional hair and scalp care with soothing sensory elements to create a truly restorative experience. Ideal for women who long to unplug, unwind, and enjoy an hour devoted entirely to themselves.",
    includes: [
      "Gentle hair brushing",
      "Scalp massage and relaxation",
      "Aromatherapy",
      "Sound healing",
      "Reiki",
      "Warm eye pillow",
      "Herbal tea",
    ],
  },
  {
    id: "soft-sanctuary",
    name: "The Soft Sanctuary",
    duration: "90 Minutes",
    price: "$177",
    tagline: "Deeper relaxation and extended care.",
    image: "/images/service-2.jpg",
    intro:
      "An immersive experience created for women who need more than a moment of rest.",
    description:
      "The Soft Sanctuary offers extended time to settle into a deeper state of relaxation, allowing the body and mind to unwind at a slower pace. With additional time for sound healing, Reiki, and scalp care, this experience encourages profound rest, renewal, and restoration.",
    includes: [
      "Everything in The Sacred Crown Ritual",
      "Extended scalp massage and relaxation",
      "Additional sound healing",
      "Extended Reiki session",
      "Guided relaxation",
      "Herbal tea",
    ],
  },
  {
    id: "divine-feminine",
    name: "The Divine Feminine Ritual",
    duration: "120 Minutes",
    price: "$222",
    tagline: "Your luxury flagship experience.",
    image: "/images/service-3.jpg",
    intro:
      "A luxurious two-hour experience designed for women who are ready to fully exhale.",
    description:
      "The Divine Feminine Ritual is Sacred Crown Studio's most indulgent offering, blending nurturing hair and scalp care with restorative wellness practices to create a deeply personalized experience. Thoughtfully curated to encourage relaxation, reflection, and renewal, this extended session allows you to disconnect from the outside world and reconnect with yourself.",
    longDescription:
      "Begin with herbal tea or ceremonial cacao as you settle into the space. From there, you'll be guided through a carefully layered experience featuring gentle hair brushing, scalp massage, sound healing, Reiki, meditation, and intentional moments of stillness. Every session is tailored to your needs, creating a sanctuary of comfort, care, and relaxation.",
    closing:
      "A signature experience for women seeking deep rest, nurturing, and renewal.",
    includes: [
      "Gentle hair brushing",
      "Extended scalp massage and relaxation",
      "Aromatherapy",
      "Sound healing",
      "Reiki",
      "Guided meditation",
      "Warm eye pillow",
      "Herbal tea or ceremonial cacao",
      "Personalized care and intention setting",
    ],
  },
];
